import { RollemasterForKurv } from './../../../models/rollemasterForKurv';
import RequestService from '../requestService';
import { client } from '../../client';


export default class RollemasterForKurvService extends RequestService<RollemasterForKurv, 'rollemasterForKurv'> {
  loadEksportFile = async (id: string | number, fileName: string) => {
    try {
      const blob = await client.get<Blob>(`${this.serviceName}/eksportRollemasterForKurv/${encodeURIComponent(id)}`, {
        headers: {
          ResponseType: 'blob',
        },
      });
      return new File([blob], fileName);
    } catch (err) {
      return null;
    }
  };
}
